module.exports = __webpack_public_path__ + "media/תולעת.de2abdf4.mp3";